import { TypedDocumentNode, gql } from '@apollo/client';

import PostalAddressForm from 'components/settings/PostalAddressForm';
import useMutation from 'hooks/graphql/useMutation';

import {
  DeletePostalAddressMutation,
  DeletePostalAddressMutationVariables,
} from './__generated__/useDeleteUserPostalAddress.graphql';

const QUERY = gql`
  mutation DeletePostalAddressMutation($input: deletePostalAddressInput!) {
    deletePostalAddress(input: $input) {
      currentUser {
        slug
        id
        userSettings {
          id
          ...PostalAddressForm_userSettings
        }
      }
      errors {
        message
        code
      }
    }
  }
  ${/* eslint-disable-next-line sorare/no-detached-fragments */ ''}
  ${PostalAddressForm.fragments.userSettings}
` as TypedDocumentNode<
  DeletePostalAddressMutation,
  DeletePostalAddressMutationVariables
>;

export default () => {
  const [mutate, { loading }] = useMutation(QUERY, {
    showErrorsWithSnackNotification: true,
  });

  return {
    deleteUserPostalAddress: async () => mutate({ variables: { input: {} } }),
    loading,
  };
};
